import createCache from '@emotion/cache';

/**
 * Creates an Emotion style cache with `prepend: true` so MUI styles are
 * inserted before any other `<style>` tags, preserving specificity order.
 *
 * - Called once on the server (per request, inside _document getInitialProps)
 *   to allow @emotion/server to extract critical CSS into the SSR HTML.
 * - Called once on the client (module level in _app) as the shared session cache.
 */
export default function createEmotionCache() {
  return createCache({ key: 'css', prepend: true });
}
